export default {
    'diagram12-3a1': {
        'diagram-number': '12.',
        'elements': {
            'one': 'Global oil and gas markets are part of a dense network of economic linkages and connections',
            'two': 'These connections generate tensions, particularly around trade and currencies',
            'three': 'China’s growth will bring about a new balance in the market, generating new tensions',
            'four': 'Important not to recast normal petro rivalry into a contest of nation states',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram12/i18n/en.js